import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { ToolTipPopUpModal } from "./ToolTipPopUpModal.js";
/* empty css                       */
const ToolTipPopUpModalContainer = (props) => {
  const { useIsPhone } = MediaQuery;
  const isPhone = useIsPhone();
  return /* @__PURE__ */ React.createElement(ToolTipPopUpModal, { ...props, isPhone });
};
export {
  ToolTipPopUpModalContainer,
  ToolTipPopUpModalContainer as default
};
//# sourceMappingURL=ToolTipPopUpModalContainer.js.map
